import BookOpenIcon from '@heroicons/react/outline/BookOpenIcon'
import ChevronRightIcon from '@heroicons/react/outline/ChevronRightIcon'
import ViewGridIcon from '@heroicons/react/outline/ViewGridIcon'
import { matchPath, useLocation } from 'react-router'
import { Link } from 'react-router-dom'

import { AppInstallation, Image } from '@tribeplatform/gql-client/types'
import { useAppInstallations } from '@tribeplatform/react-sdk/hooks'
import { simplifyPaginatedResult } from '@tribeplatform/react-sdk/utils'
import { Avatar } from '@tribeplatform/react-ui-kit/Avatar'
import { NavVertical } from '@tribeplatform/react-ui-kit/Sidebar'

import { blocklistApps } from '../Apps'

export const AppsSidebarContent = () => {
  const location = useLocation()

  const { data: appInstallationsData } = useAppInstallations({
    variables: {
      limit: 10,
    },
    fields: {
      app: {
        image: 'all',
      },
    },
  })
  const { nodes: allAppInstallations } =
    simplifyPaginatedResult<AppInstallation>(appInstallationsData)

  const appInstallations = allAppInstallations.filter(
    ai => ai.app.name !== 'discussion' && ai.app.name !== 'q-and-a',
  )

  return (
    <NavVertical className="p-3">
      <NavVertical.Group>
        <h3 className="px-2 my-3">Apps</h3>
        <NavVertical.Item
          active={
            !!matchPath(location.pathname, {
              path: '/manage/apps',
              exact: true,
            })
          }
          as={Link}
          leadingIcon={<ViewGridIcon />}
          to="/manage/apps"
        >
          All apps
        </NavVertical.Item>
        {appInstallations?.map(appInstallation => {
          if (blocklistApps.indexOf(appInstallation?.app?.slug) !== -1)
            return null
          return (
            <NavVertical.Item
              active={
                !!matchPath(location.pathname, {
                  path: `/manage/apps/${appInstallation?.app?.slug}`,
                  exact: true,
                })
              }
              as={Link}
              leadingIcon={
                <Avatar
                  size="xs"
                  rounded="md"
                  name={appInstallation?.app?.name}
                  src={(appInstallation?.app?.image as Image)?.url}
                />
              }
              to={`/manage/apps/${appInstallation?.app?.slug}`}
              key={appInstallation.id}
            >
              {appInstallation.app.name}
            </NavVertical.Item>
          )
        })}
        <NavVertical.Item
          as="a"
          target="_blank"
          rel="noopener noreferrer"
          href="https://partners.tribe.so/docs/guide/index/"
          leadingIcon={<BookOpenIcon />}
          trailingIcon={<ChevronRightIcon />}
        >
          Developers guide
        </NavVertical.Item>
      </NavVertical.Group>
    </NavVertical>
  )
}
